import { gql } from '@apollo/client';
import FEATURE_SET_DETAILS_FRAGMENT from './FeatureSetDetailsFragment.graphql.js';

export const BILLING_SUBSCRIPTION_OPTION_DETAILS_FRAGMENT = gql`
  fragment BillingSubscriptionOptionDetails on BillingSubscriptionOption {
    id
    cycle
    title
    price
    priceInCents
    baseMonthlyPrice
    monthlyPricePerUser
    amountSavedInCents
    stripePlanId
    billingScheme
    stripePlanId
    isSampleEligible
  }
`;

export const BILLING_PLAN_DETAILS_FRAGMENT = gql`
  fragment BillingPlanDetails on BillingPlan {
    id
    databaseId
    productId
    identifier
    eligiblePlan
    title
    weight
    subscriptionOptions {
      edges {
        node {
          ...BillingSubscriptionOptionDetails
        }
      }
    }

    messages {
      messageTitle
      content
      buttonText
      infoText
    }
  }

  ${BILLING_SUBSCRIPTION_OPTION_DETAILS_FRAGMENT}
`;

export const BILLING_SUBSCRIPTION_DETAILS_FRAGMENT = gql`
  fragment BillingSubscriptionDetails on BillingSubscription {
    id
    billableUsers
    emptySeats
    cardOnFile
    paymentSourceOnFile
    legacy
    paymentMethod
    subscriptionEnd
    subscriptionOption {
      ...BillingSubscriptionOptionDetails
    }
    previousSubscriptionOption {
      id
    }
    trialEnd
    trialed
    upcomingInvoice {
      nextPaymentAttempt
      amountDue
    }

    paymentSource {
      brand
      expMonth
      expYear
      last4
      paymentMethod
      bankName
    }
    amount
    discount {
      coupon {
        amountOff
        percentOff
      }
      discountEnd
    }
    quantity
    stripeSubscriptionId
  }

  ${BILLING_SUBSCRIPTION_OPTION_DETAILS_FRAGMENT}
`;

const BILLING_INVOICES_DETAILS_FRAGMENT = gql`
  fragment BillingInvoiceDetails on BillingInvoice {
    invoiceId
    status
    periodStart
    periodEnd
    amountPaid
    paidAt
    invoicePdf
  }
`;

export const BILLING_UPCOMING_INVOICE_DETAILS_FRAGMENT = gql`
  fragment BillingUpcomingInvoiceDetails on BillingUpcomingInvoice {
    nextPaymentAttempt
    amountDue
  }
`;

export const BILLING_ADD_ON_MESSAGING_FRAGMENT = gql`
  fragment BillingAddOnUpsellMessagingDetails on AddonUpsellMessaging {
    buttonText
    features
    messageTitle
  }
`;

export const BILLING_ADD_ON_OPTION_FRAGMENT = gql`
  fragment BillingAddOnOptionDetails on BillingAddonOption {
    cycle
    featureIdentifier
    id
    messaging {
      ...BillingAddOnUpsellMessagingDetails
    }
    formattedPrice
    priceInCents
    title
  }
`;

export const BILLING_SUBSCRIPTION_ADD_ON_FRAGMENT = gql`
  fragment BillingSubscriptionAddOnDetails on BillingSubscriptionAddon {
    id
    active
    cycle
    priceInCents
    stripeSubscriptionId
    title
    upcomingInvoice {
      ...BillingUpcomingInvoiceDetails
    }
  }
`;

export default gql`
  query CompanyBillingDetailed {
    viewer {
      id
      company {
        id
        active
        accountId
        databaseId
        projectsCount
        usersCount
        trialed
        trialEnd
        selfServiceBilling
        plan {
          id
          title
          databaseId
          identifier
        }
        featureSet {
          ...FeatureSetDetails
        }
      }
      billing {
        availablePlans {
          ...BillingPlanDetails
        }
        availableAddons {
          ...BillingAddOnOptionDetails
        }
        activeAddons {
          ...BillingSubscriptionAddOnDetails
        }
        subscription {
          ...BillingSubscriptionDetails
        }
        invoices {
          ...BillingInvoiceDetails
        }
        accountTrial {
          id
          active
          productName
          trialType
          endsAt
        }
      }
    }
  }
  ${BILLING_PLAN_DETAILS_FRAGMENT}
  ${BILLING_SUBSCRIPTION_DETAILS_FRAGMENT}
  ${BILLING_INVOICES_DETAILS_FRAGMENT}
  ${BILLING_UPCOMING_INVOICE_DETAILS_FRAGMENT}
  ${BILLING_ADD_ON_MESSAGING_FRAGMENT}
  ${BILLING_ADD_ON_OPTION_FRAGMENT}
  ${BILLING_SUBSCRIPTION_ADD_ON_FRAGMENT}
  ${FEATURE_SET_DETAILS_FRAGMENT}
`;
